import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { getPostsForRegionRu } from "@/lib/blog-data-ru";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
import { useLocation } from "@/lib/locations";

const RussianBlogPage = () => {
  const location = useLocation();
  const allPosts = getPostsForRegionRu(location.name, location.regionSlug);

  return (
    <div className="flex min-h-screen flex-col" lang="ru">
      <SEO 
        title="Блог | Uplevel Cleaning"
        description="Советы по уборке и местные гиды по Калифорнии."
        keywords="блог уборка, советы клининг"
        url="https://uplevelcleaning.com/ru/blog"
        alternateUrl="https://uplevelcleaning.com/blog"
        alternateLang="en-US"
        lang="ru"
        noindex
      />
      <Navbar />
      <main className="flex-1 pt-32 pb-24 bg-muted/10">
        <div className="container max-w-6xl">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">Наш блог</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Полезные советы и статьи от наших экспертов по уборке.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {allPosts.map((post) => (
              <Link key={post.slug} to={`/ru/blog/${post.slug}`}>
                <Card className="h-full hover:shadow-lg transition-all border-border hover:border-primary/50 overflow-hidden flex flex-col">
                  <div className="aspect-video w-full overflow-hidden">
                    <img src={post.image} alt={post.title} loading="lazy" decoding="async" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                  </div>
                  <CardHeader>
                    <div className="text-xs text-primary font-bold mb-2 uppercase tracking-wider">{post.category}</div>
                    <CardTitle className="text-xl leading-tight">{post.title}</CardTitle>
                  </CardHeader>
                  <CardContent className="flex-1 flex flex-col">
                    <p className="text-muted-foreground text-sm mb-4 flex-1">{post.excerpt}</p>
                    <div className="flex items-center justify-between text-xs text-muted-foreground">
                      <span>{post.date}</span>
                      <span className="flex items-center text-primary font-medium">
                        Читать <ArrowRight className="ml-1 h-3 w-3" />
                      </span>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default RussianBlogPage;
